import { BulkRequestEditModal } from "./BulkRequestEditModal";
import { show } from "@ebay/nice-modal-react";
import type { BulkRequestRecord } from "api/clients/useBulkRequestQuery";
import type { SaveCallback } from "./useChangeOverlay";

/** Display the Bulk Request editing modal dialog. */
export async function showBulkRequestEditModal(record: BulkRequestRecord, save: SaveCallback) {
    return await show(BulkRequestEditModal, { record, save });
}
